import { QuotePlanSchema } from '../../../server/map-quotes';

export const filterWithKeyBenefitId = (filteredQuotes: QuotePlanSchema[], keyBenefitId: number[]) =>
	filteredQuotes.filter((obj) =>
		obj.planKeyBenefits.some((planObj) => planObj.isKeyBenefit && keyBenefitId?.includes(planObj.benefitCategoryId))
	);
